import {observer} from "mobx-react";
import {ScrollTable} from "../../ui";
import {displayReceiptType} from "../../../api";
import {ReceiptListItemDto} from "../../../api/kpi";

interface ReceiptTableProps {
    data: ReceiptListItemDto[]
}

const ReceiptTable = observer(function ReceiptTable({data}: ReceiptTableProps) {
    return <>

        <div style={{
            paddingBottom: '1em',
            display: 'flex',
            flex: 1
        }}>
            <ScrollTable>
                <thead>
                <tr>
                    <th>Datum</th>
                    <th>Anzahl</th>
                    <th>Art</th>
                </tr>
                </thead>
                <tbody>
                {data.map(e => (
                    <tr key={`${e.receiptType}+${e.date}`}>
                        <td>{(new Date(e.date)).toLocaleDateString('de')}</td>
                        <td>{e.count}</td>
                        <td>{displayReceiptType(e.receiptType)}</td>
                    </tr>
                ))}
                </tbody>

            </ScrollTable>
        </div>
    </>
})

export {
    ReceiptTable
}
